import { render, staticRenderFns } from "./set-questions.vue?vue&type=template&id=5bdb9454&scoped=true"
import script from "./set-questions.vue?vue&type=script&lang=ts"
export * from "./set-questions.vue?vue&type=script&lang=ts"
import style0 from "./set-questions.vue?vue&type=style&index=0&id=5bdb9454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb9454",
  null
  
)

export default component.exports